<template>
  <div>
    <a-modal v-model="show" footer="'" title="取消订单" width="650px">
      <a-form :form="cancelOrderModal">
        <a-row>
          <a-col>
            <a-form-item v-if="foreignType!=4&&foreignType!=6" label="师傅姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-input v-decorator="['name', { rules: [{ required: true, message: '请填写师傅姓名' }] }]" />
            </a-form-item>
            <a-form-item v-if="foreignType!=4&&foreignType!=6" label="师傅手机号" :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-input v-decorator="['tel', { rules: [{ required: true, message: '请填写师傅手机号' }] }]" />
            </a-form-item>
            <a-form-item label="取消原因" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                @change="getReason"
                v-decorator="['reason', { rules: [{ required: true, message: '请填写取消原因' }] }]"
              >
                <a-select-option v-for="type in reasonArr" :key="type.dictValue" :value="type.dictValue">{{
                  type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea v-decorator="['remark', { rules: [{ required: isMi, message: '请填写取消备注' }] }]" />
            </a-form-item>
          <!--6萤石&已上门，客户取消服务 需要上传图片cancelSignPic-->
            <a-form-item v-if="foreignType==6&&cancelReasonName=='已上门，客户取消服务'" label="上传图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-upload name="file" list-type="picture-card" :fileList="picFileList"
                class="avatar-uploader" :headers="headers" :data="{ type: 6 }" :action="uploadSignUrl"
                :before-upload="beforeUpload" @preview="handlePreview"
                @change="signatureChange($event, index)" v-decorator="['picFileList', { rules: [{ required: true, message: '请上传图片' }] }]">
                <div v-if="picFileList.length < 1">
                  <a-icon type="upload" />
                  <div class="ant-upload-text">上传图片</div>
                </div>
              </a-upload> 
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item v-if="isMi" label="验证码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                style="width: 69%; margin-right: 20px"
                v-decorator="['code', { rules: [{ required: true, message: '请填写取消验证码' }] }]"
              />
              <a-button type="primary" @click="getCode"> 获取验证码 </a-button>
            </a-form-item>
          </a-col>
          <a-col>
            <a-row type="flex" justify="center">
              <a-col class="flex flex-center">
                <a-button @click="orderRemoveSubstatus"> 取消 </a-button>
                <a-button type="primary" @click="submit" style="margin-left: 30px"> 提交 </a-button>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewhandleCancel">
      <img alt="example" style="width: 100%; padding: 10px" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getDictionary, getCancelReason } from '@/api/workflow/dictionaries'
import { getCancelCode, submitCancel } from '@/api/order/orderList'
export default {
  name: 'SelectOrderFrozenModel',
  components: {},
  data () {
    return {
      previewVisible: false,
      previewImage: '',
      picFileList:[],
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      uploadSignUrl: process.env.VUE_APP_API_BASE_URL + '/dfs/uploadSaleData',
      show: false,
      isMi: false,
      orderId: '',
      name: '',
      tel: '',
      reasonArr: [],
      reason: '',
      cancelReasonName:'',
      remark: '',
      code: '',
      foreignType: '', // 区分绿米还是欧瑞博 6萤石
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      cancelOrderModal: this.$form.createForm(this)
    }
  },
  methods: {
    beforeUpload(file) {
      // console.log(file)
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('上传文件格式不支持!')
        return false
      }
    },
    handlePreview(file) {
      console.log(file)
      if (!file.url && !file.preview) {
        file.preview = file.thumbUrl
      } else {
        file.url = file.url
      }
      this.previewImage = file.url || file.preview
      // console.log(this.previewImage)
      this.previewVisible = true
    },
    signatureChange({ fileList }){
      this.picFileList=fileList
    },
    previewhandleCancel() {
      this.previewVisible = false
    },
    async getCancelReason () {
      try {
        const res = await getCancelReason({ foreinType: this.foreignType })
        this.reasonArr = res.data
      } catch (err) {
        console.log(err)
      }
    },
    showCancel (id, type, foreignType) {
      this.show = true
      this.orderId = id
      this.foreignType = foreignType
      if (type == 'xiaomi') {
        this.isMi = true
      } else {
        this.isMi = false
      }
      this.cancelOrderModal.resetFields()
      if (this.foreignType == 3 || this.foreignType == 4|| this.foreignType == 6) {
        this.getCancelReason()
      } else if (this.reasonArr.length == 0) {
        getDictionary({ pageNum: 1, pageSize: 50, dictType: 'cancel_reason' }).then((res) => {
          if (res.code === 0) {
            this.reasonArr = res.rows
            console.log(this.reasonArr)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 取消原因
    getReason (value) {
      this.reason = value
      // 获取对应的Name
      this.cancelReasonName=this.reasonArr.filter(item=>item.dictValue==value)[0].dictLabel
    },
    getCode () {
      this.cancelOrderModal.validateFields(['name', 'tel', 'remark', 'reason'], (err, values) => {
        console.log(11111111111, err, values)
        if (!err) {
          getCancelCode({
            orderId: this.orderId,
            cancelReasonId: values.reason,
            remark: values.remark,
            opPersonName: values.name,
            opPersonTel: values.tel
          }).then((res) => {
            if (res.code === 0) {
              this.$message.success('发送成功')
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 提交
    submit () {
      this.cancelOrderModal.validateFields((err, values) => {
        console.log(values,this.cancelReasonName,this.picFileList)
        if (!err) {
            submitCancel({
              orderId: this.orderId,
              cancelReasonId: values.reason,
              remark: values.remark,
              opPersonName: values.name,
              opPersonTel: values.tel,
              closeVerifyCode: values.code,
              cancelSignPic: this.picFileList[0]?this.picFileList[0].response.url:'',
              cancelReasonName:this.cancelReasonName
            }).then((res) => {
              if (res.code === 0) {
                this.$message.success('提交成功')
                this.$emit('ok')
                this.show = false
              } else {
                this.$message.error(res.msg)
              }
            })
        }
      })
    },
    // 取消冻结
    orderRemoveSubstatus () {
      this.show = false
    }
  }
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  padding: 6px 16px;
}

.disEvents {
  pointer-events: none;
}
</style>
